// Polyfills (Dynamically loaded if lacking native browser support)
if (typeof window !== 'undefined') {
    // Invokers
    // MDN: https://developer.mozilla.org/en-US/docs/Web/API/CommandEvent/source
    // Git: https://github.com/keithamus/invokers-polyfill
    /*if (!('commandFor' in HTMLButtonElement.prototype)) {
        import(
            /!* webpackChunkName: "invokers-polyfill" *!/
            "invokers-polyfill/fn"
            ).then(({ apply }) => apply());
    }*/

    // Dialog closedBy
    // MDN: https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement/closedBy
    // Git: https://github.com/tak-dcxi/dialog-closedby-polyfill
    if (!('closedBy' in HTMLDialogElement.prototype)) {
        import(
            /* webpackChunkName: "dialog-closedby-polyfill" */
            "dialog-closedby-polyfill"
            ).then(({ isPolyfilled }) => {
            // Applied automatically upon import
        });
    }

    // Popover API
    // MDN: https://developer.mozilla.org/en-US/docs/Web/API/Popover_API
    // Git: https://github.com/oddbird/popover-polyfill
    if (!('popover' in HTMLElement.prototype)) {
        import(
            /* webpackChunkName: "popover-polyfill" */
            "@oddbird/popover-polyfill/fn"
            ).then(({ apply }) => apply());
    }

    // Scoped Focusgroup
    // MDN: https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/focusgroup
    // Explainer: https://open-ui.org/components/scoped-focusgroup.explainer/
    // Git: https://github.com/doeixd/scoped-focusgroup-polyfill
    import(
        /* webpackChunkName: "scoped-focusgroup-polyfill" */
        "@doeixd/scoped-focusgroup-polyfill"
        );

    // CSS Anchor Positioning
    // MDN: https://developer.mozilla.org/en-US/docs/Web/CSS/Guides/Anchor_positioning
    // Docs: https://anchor-positioning.oddbird.net/
    // Git: https://github.com/oddbird/css-anchor-positioning
    if (!(window.CSS && CSS.supports('top', 'anchor(--test bottom)'))) {
        import(
            /* webpackChunkName: "css-anchor-positioning-polyfill" */
            "@oddbird/css-anchor-positioning"
            );
    }

    // CSS :has() Relational Pseudo-class
    // MDN: https://developer.mozilla.org/en-US/docs/Web/CSS/:has
    // Git: https://github.com/csstools/postcss-plugins/tree/main/plugins/css-has-pseudo
    if (!(window.CSS && CSS.supports('selector(:has(*))'))) {
        import(
            /* webpackChunkName: "css-has-pseudo-polyfill" */
            "css-has-pseudo/browser"
            ).then(({ default: cssHasPseudo }) => cssHasPseudo(document));
    }
}